import { PositionBillingRatesActions } from './../actions/positionBillingRatesActions';
import { IPositionBillingRate } from './../types/department';
import { IPosition } from "../types/department";
import { _initialPosition } from './departments';
import * as constants from '../actions/constants'


export const _initialPositionBillingRate: IPositionBillingRate = {
  id: '',
  position_name: '',
  position_id: '',
  billing_rate: 0,
  start_date:  null,
  end_date:  null
}

export const selectedPosition = (state: IPosition = _initialPosition , action: PositionBillingRatesActions): IPosition => {
  switch (action.type) {
    case constants.SELECT_POSITION:
      return action.position

    default:
      return state
  }
}


export const modifiedPosBillingRate = (state: IPositionBillingRate = _initialPositionBillingRate, action: PositionBillingRatesActions): IPositionBillingRate => {
  switch (action.type) {
    case constants.CREATE_POSITION_BILLING_RATE_SUCCESS:
    case constants.UPDATE_POSITION_BILLING_RATE_SUCCESS:
      return action.billingRate

    default:
      return state
  }
}
